import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {
  }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: "0"
    };

    return new HttpHeaders(headersConfig);
  }

  private setHeadersForm(customHeaders?: HttpHeaders["headers"]): HttpHeaders {
    const headersConfig = customHeaders
      ? {
        ...customHeaders,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
      : {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };

    return new HttpHeaders(headersConfig);
  }

  private formatErrors(error: any) {
    return throwError(error.error.message || error);
  }

  get(path: string, params: any = {}, headers?: HttpHeaders["headers"]): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      if (
        params[key] !== '' &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        httpParams = httpParams.append(key, params[key]);
      }
    });
    return this.http
      .get<any>(`${environment.apiUrl}${path}`, {
        headers: headers ? this.setHeadersForm(headers) : this.setHeaders(),
        params: httpParams,
      })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, payload: Object = {}): Observable<any> {
    return this.http
      .put<any>(`${environment.apiUrl}${path}`, JSON.stringify(payload), {
        headers: this.setHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  patch(path: string, payload: Object = {}, headers?: HttpHeaders["headers"]): Observable<any> {
    return this.http
      .patch<any>(`${environment.apiUrl}${path}`, JSON.stringify(payload), {
        headers: headers ? this.setHeadersForm(headers) : this.setHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, payload: Object = {}, headers?: HttpHeaders["headers"]): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}${path}`, JSON.stringify(payload), {
        headers: headers ? this.setHeadersForm(headers) : this.setHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  postProject(path: string, payload: Object = {}, headers?: HttpHeaders["headers"]): Observable<any> {
    return this.http
      .post<any>(`${environment.projectUrl}${path}`, JSON.stringify(payload), {
        headers: headers ? this.setHeadersForm(headers) : this.setHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  sentProjectValidation(path: string, payload: Object = {}, headers?: HttpHeaders["headers"]): Observable<any> {
    return this.http
      .post<any>(`${environment.testSv}/api${path}`, JSON.stringify(payload), {
        headers: headers ? this.setHeadersForm(headers) : this.setHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  delete(path: any, params?: any): Observable<any> {
    const options: any = {
      headers: this.setHeaders(),
    };
    if (params) {
      options.params = params;
    }
    return this.http
      .delete<any>(`${environment.apiUrl}${path}`, options)
      .pipe(catchError(this.formatErrors));
  }
}
